import styled from 'styled-components'
import { breakpoints } from '../../../breakpoints'
export const MainLogoImg = styled.img`
  height: 100%;
  width: 100%;
`